import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React, { FocusEvent, FunctionComponent, MouseEvent } from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { closeTooltip } from '../notifications/Tooltip';
import { InfoButton } from './InfoIcon.style';

interface IconProps {
  onClick?: (e: MouseEvent) => void;
  onMouseEnter?: (e: MouseEvent) => void;
  onMouseLeave?: (e: MouseEvent) => void;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  color?: string;
  icon?: any;
  fontSize?: number;
  testID?: string;
  className?: string;
  style?: React.CSSProperties;
}

const InfoIcon: FunctionComponent<IconProps> = (props) => {
  return (
    <InfoButton
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave || closeTooltip}
      onFocus={props.onFocus}
      onBlur={props.onBlur || closeTooltip}
      data-testid={props.testID || 'info-icon'}
      className={props.className}
      type="button"
      style={props.style}
    >
      <FontAwesomeIcon
        icon={props.icon || faInfoCircle}
        color={props.color || 'white'}
        style={{ fontSize: props.fontSize || 14 }}
      />
    </InfoButton>
  );
};

export default InfoIcon;
